var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checkmark Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Events",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-List-(Admin)-Copy-2",
    transform: "translate(-1054.000000, -760.000000)",
    fill: "#3f6d6e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    transform: "translate(1054.000000, 760.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.81818182,7.11940299 L1.09266459,4.43456512 C1.0163835,4.35942255 0.891915061,4.36020307 0.805397727,4.4454291 L0.149147727,5.09188433 C0.066775712,5.17302691 0.0662716952,5.30408854 0.14501485,5.38165642 L3.67316697,8.85714955 C3.75325646,8.93604368 3.88891411,8.93032342 3.96019259,8.86010879 L11.8579892,1.08018972 C11.9364196,1.00292994 11.9373696,0.878602896 11.8508523,0.793376866 L11.1946023,0.146921642 C11.1122303,0.0657790596 10.9829744,0.0615476494 10.9075337,0.135862278 L3.81818182,7.11940299 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.2b59eddfaacbe38bd1ecf73af430300b.svg";
export { ForwardRef as ReactComponent };